<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="应收期初"
      edit-title
      id-key="BeginningId"
      :data="data"
      :form-rules="rules"
      form-label-width="110px"
      :get-data-func="api.info"
      :save-func="api.save"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="往来单位" prop="TradeUnitName">
              <customer  @restaurants='setSupplier' :state='data.TradeUnitName'/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应收金额" prop="Amount">
              <el-input v-model="data.Amount" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="其他应收金额" prop="OtherAmount">
              <el-input v-model="data.OtherAmount" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预收金额" prop="PreAmount">
              <el-input v-model="data.PreAmount" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="期初日期" prop="BeginningDate">
              <el-date-picker
                size="mini"
                v-model="data.BeginningDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
                :editable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款到期日" prop="ExpireDate">
              <el-date-picker
                size="mini"
                v-model="data.ExpireDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
                :editable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    unitDialog,
    customer
  },
  data() {
    return {
      data: {
        BeginningId: 0,
        TradeUnitId: 0,
        Amount: null,
        OtherAmount: null,
        PreAmount: null,
        BeginningDate: "",
        ExpireDate: "",
        Payment: false,
        Status: 0,
        EntId: 0,
        TradeUnitType: 0,
        TradeUnitName: "",
      },
      api: require("@/api/sy/trade").default,
      rules: {
        TradeUnitName: [{ required: true, message: "往来单位不能为空" }],
        Amount: [{ required: true, message: "应收金额不能为空" }],
        OtherAmount: [{ required: true, message: "其他应收金额不能为空" }],
        PreAmount: [{ required: true, message: "预收金额不能为空" }],
        BeginningDate: [{ required: true, message: "期初日期不能为空" }],
        ExpireDate: [{ required: true, message: "收款到期日不能为空" }],
      },
    };
  },
  methods: {
    setSupplier(data) {
      
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.TradeUnitName;
      this.data.TradeUnitType = data.CustomerType;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      
      this.data.TradeUnitId = e.Id;
      this.data.TradeUnitName = e.Name;
      this.data.TradeUnitType = e.TradeUnitType;
    },
  },
};
</script>
<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>